import React, { useState } from "react";
import "./PlanQuestionnaire.css";

const STEPS = [
  {
    type: "question",
    id: "motivation",
    question: "What's driving you to write this?",
    options: [
      { label: "Writing my own reality", value: "reality"    },
      { label: "Feeling stuck",          value: "stuck"      },
      { label: "Regular reflection",     value: "reflection" },
      { label: "Other",                  value: "other"      },
    ],
    multi: false,
  },
  {
    type: "info",
    id: "whats_a_vision",
  },
];

const VisionInfoScreen = () => (
  <div className="pq-info-block">
    <h2 className="pq-question">What's a Vision?</h2>

    <p className="pq-info-body">
      A vision is a declaration of the reality you're building — written before it exists.
      Think of it as a time capsule. One day your future self, and the people around you,
      will look back and see exactly how you created what wasn't there yet.
    </p>

    <div className="pq-info-divider" />

    <p className="pq-info-label">How it works</p>
    <div className="pq-info-points">
      <div className="pq-info-point">
        <span className="pq-info-dot" />
        <span>Pick the areas of your life you want to move - Career, Health, Wealth, Relationships, or anything you define.</span>
      </div>
      <div className="pq-info-point">
        <span className="pq-info-dot" />
        <span>Write what that area looks like when you've built it. A reality you decide should exist.</span>
      </div>
      <div className="pq-info-point">
        <span className="pq-info-dot" />
        <span>Document the process as you go. The updates become the proof.</span>
      </div>
    </div>
  </div>
);

const PlanQuestionnaire = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({ motivation: null });

  const step = STEPS[currentStep];
  const progress = ((currentStep + 1) / STEPS.length) * 100;

  const isAnswered = () => {
    if (step.type === "info") return true;
    const val = answers[step.id];
    if (step.multi) return val && val.length > 0;
    return val !== null;
  };

  const handleSelect = (value) => {
    setAnswers((prev) => ({ ...prev, [step.id]: value }));
  };

  const handleNext = () => {
    if (currentStep < STEPS.length - 1) {
      setCurrentStep((prev) => prev + 1);
    } else {
      onComplete({ duration: 5, categories: [] });
    }
  };

  const handleBack = () => {
    if (currentStep > 0) setCurrentStep((prev) => prev - 1);
  };

  const isLastStep = currentStep === STEPS.length - 1;

  return (
    <div className="pq-container">

      {/* PROGRESS BAR */}
      <div className="pq-progress-track">
        <div className="pq-progress-fill" style={{ width: `${progress}%` }} />
      </div>
      <div className="pq-step-label">{currentStep + 1} / {STEPS.length}</div>

      {/* CONTENT */}
      {step.type === "question" && (
        <>
          <div className="pq-question-block">
            <h2 className="pq-question">{step.question}</h2>
            {step.subtitle && <p className="pq-subtitle">{step.subtitle}</p>}
          </div>
          <div className="pq-options pq-options-stack">
            {step.options.map((opt) => {
              const selected = answers[step.id] === opt.value;
              return (
                <button
                  key={opt.value}
                  className={`pq-option-btn pq-option-row ${selected ? "selected" : ""}`}
                  onClick={() => handleSelect(opt.value)}
                  type="button"
                >
                  <span className="pq-option-label">{opt.label}</span>
                </button>
              );
            })}
          </div>
        </>
      )}

      {step.type === "info" && <VisionInfoScreen />}

      {/* NAV */}
      <div className="pq-nav">
        {currentStep > 0 && (
          <button className="pq-back-btn" onClick={handleBack} type="button">
            Back
          </button>
        )}
        <button
          className="pq-next-btn"
          onClick={handleNext}
          disabled={!isAnswered()}
          type="button"
        >
          {isLastStep ? "Build my Vision" : "Next"}
        </button>
      </div>

    </div>
  );
};

export default PlanQuestionnaire;
